import ItemsCountingReport from './itemsCountingReportContainer';

export default ItemsCountingReport;
